import { useState } from "react"
import { useMutation, useQuery } from "react-query"
import { createMediaField, fetchMediaFields } from "api/globalMediaTypes"
import { globalState } from "../List"
import {
  MediaConfigScope,
  MediaField,
  MediaFieldType,
} from "../../GlobalMediaTypes/types"
import { ApiError, ErrorsMap } from "api/http/utils"
import { AddNewTableRow } from "../../components/AddNewTableRow"

type Props = {
  onClose: VoidFunction
  isLoading: boolean
  configScope?: MediaConfigScope
  configOwnerId?: string
}

export const AddNewField = (props: Props) => {
  const { onClose, isLoading, configScope = "GLOBAL", configOwnerId } = props
  const [state, setState] = useState<Partial<MediaField> | undefined>({})
  const [errors, setErrors] = useState<ErrorsMap | undefined>()

  // ** refetch fields
  const { data } = useQuery(
    ["global-media-fields", { configScope, configOwnerId }],
    fetchMediaFields,
    {
      onSuccess: (d: MediaField[]) => {
        globalState.setData(d)
      },
    },
  )

  // ** create new field
  const [create] = useMutation(createMediaField, {
    onSuccess: (d: MediaField) => {
      globalState.addRow({ ...d, mediaTypes: [] })
      setErrors(undefined)
      onClose()
    },
    onError: (err: ApiError) => {
      const error = err as ApiError
      const errorMap = error?.errorsMap ?? {}
      setErrors(errorMap)
    },
  })

  const onChange = (name: string, value: string) => {
    setState((s) => ({ ...s, [name]: value }))
    setErrors(undefined)
  }

  const onSelectChange = (
    option: {
      label: string | undefined
      value: string | undefined
    } | null,
  ) => {
    setState(data?.find((d) => d?.name === option?.label))
    setErrors(undefined)
  }

  const handleCreate = () => {
    const pld = {
      configScope: configScope || "GLOBAL",
      configOwnerId,
      name: state?.name,
      semanticCode: state?.semanticCode,
      type: state?.type || ("String" as MediaFieldType),
      formulaSet: state?.formulaSet, // Required only for type Calculated
      options: state?.options, // Required only for type List
    }
    create(pld)
  }

  return (
    <AddNewTableRow<MediaField>
      onClose={onClose}
      isLoading={isLoading}
      onChange={onChange}
      onSelectChange={onSelectChange}
      handleCreate={handleCreate}
      data={data}
      row={state}
      errors={errors}
      labelParam="admin.mediaFields.field"
      fieldName="name"
    />
  )
}
